
export default function GlobalReach() {
  const regions = [
    { name: 'United States', flag: '🇺🇸' },
    { name: 'United Kingdom', flag: '🇬🇧' },
    { name: 'Canada', flag: '🇨🇦' },
    { name: 'Australia', flag: '🇦🇺' },
    { name: 'Germany', flag: '🇩🇪' },
    { name: 'UAE', flag: '🇦🇪' },
    { name: 'Saudi Arabia', flag: '🇸🇦' },
    { name: 'India', flag: '🇮🇳' },
    { name: 'Pakistan', flag: '🇵🇰' },
    { name: 'Egypt', flag: '🇪🇬' },
    { name: 'Qatar', flag: '🇶🇦' },
    { name: '+ 40 more countries', flag: '🌍' },
  ];

  return (
    <section id="global" className="py-[120px] bg-[#0A0E1A]">
      <div className="max-w-[1280px] mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-5xl font-extrabold text-white mb-6 leading-tight">
            Built for job seekers everywhere.<br />
            Not just Silicon Valley.
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-[800px] mx-auto leading-relaxed">
            JobOS works on every major job board globally. Whether you're searching
            in New York, London, Dubai, Toronto, or anywhere else — the same powerful
            tools work for you. Full support for LinkedIn, Indeed, Glassdoor, and every
            major ATS used by global employers, plus Rozee.pk and Naukri for South Asia
            and MENA job seekers.
          </p>
        </div>

        {/* Region Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 max-w-[1000px] mx-auto">
          {regions.map((region, index) => (
            <div
              key={index}
              className="h-10 px-5 bg-[#141828]/50 border border-[#2D3148] rounded-full flex items-center justify-center gap-2"
            >
              <span className="text-base">{region.flag}</span>
              <span className="text-[#94A3B8] text-sm font-medium whitespace-nowrap">
                {region.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
